import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { PhoneButtonMobileContainer, PhoneButtonTabletContainer } from '../PhoneButton';

export const ShowContactsLayoutContainer: React.FC = () => {
  return (
    <>
      <Responsive phone>
        <PhoneButtonMobileContainer />
      </Responsive>
      <Responsive tablet>
        <PhoneButtonTabletContainer />
      </Responsive>
    </>
  );
};
